import type { SliderState } from './cost-to-build-client-ui-slider.types';

export const SLIDER_INITIAL_STATE: SliderState = {
    ariaLabel: '',
    id: '',
    label: 'Surface de l’extension',
    max: 40,
    min: 15,
    step: 1,
    tooltipVisible: false,
    value: 25,
};

export const areSliderStatesEqual = (left: SliderState, right: SliderState) =>
    left.ariaLabel === right.ariaLabel &&
    left.id === right.id &&
    left.label === right.label &&
    left.max === right.max &&
    left.min === right.min &&
    left.step === right.step &&
    left.tooltipVisible === right.tooltipVisible &&
    left.value === right.value;
